export default "__VITE_ASSET__a65d8b9c__"